/* SOURCE MODE — animated size guide drawer */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('PopupModal-popup_wdVdtm');
  if (!modal || modal.dataset.sourceDrawerReady === 'true') return;

  modal.dataset.sourceDrawerReady = 'true';

  const closeButton = modal.querySelector('[id^="ModalClose-"]');
  const originalHide = typeof modal.hide === 'function' ? modal.hide.bind(modal) : null;
  let closing = false;

  const closeAnimated = () => {
    if (closing || !modal.hasAttribute('open')) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !originalHide) {
      originalHide?.();
      return;
    }

    closing = true;
    modal.classList.add('source-drawer-closing');

    window.setTimeout(() => {
      originalHide();
      modal.classList.remove('source-drawer-closing');
      closing = false;
    }, 580);
  };

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeAnimated();
    }, true);
  }

  modal.addEventListener('click', (event) => {
    if (event.target !== modal) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeAnimated();
  }, true);

  modal.addEventListener('keyup', (event) => {
    if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeAnimated();
  }, true);
});

/* SOURCE MODE — size guide overlay cursor */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('PopupModal-popup_wdVdtm');
  const mouseCursor = document.getElementById('mouse-cursor');

  if (!modal || !mouseCursor || modal.dataset.sourceCursorReady === 'true') return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  modal.dataset.sourceCursorReady = 'true';

  const hideCursor = () => {
    mouseCursor.classList.remove('active');
  };

  modal.addEventListener('pointermove', (event) => {
    if (event.target === modal && modal.hasAttribute('open')) {
      mouseCursor.classList.add('active');
    } else {
      hideCursor();
    }
  }, { passive: true });

  modal.addEventListener('pointerleave', hideCursor, { passive: true });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      window.setTimeout(hideCursor, 620);
    }
  }, true);
});
